import React, { useState } from "react";
import { Section, EmptyState } from "../shared";
import KeysList from "./KeysList";
import GenerateKeyModal from "./GenerateKeyModal";
import KeyCreatedModal from "./KeyCreatedModal";
import NormaAlert from "../../../components/custom-modal/normal-alert";
import { revokeMcpKey } from "../../../api/mcpApi";
import { toast } from "react-hot-toast";

export default function ApiKeysSection({ keys, onKeysChanged, loading }) {
  const [showGenerate, setShowGenerate] = useState(false);
  const [createdKeyData, setCreatedKeyData] = useState(null);
  const [revokeTarget, setRevokeTarget] = useState(null);
  const [revoking, setRevoking] = useState(false);

  const handleKeyCreated = (data) => {
    setShowGenerate(false);
    setCreatedKeyData(data);
  };

  const handleKeyCreatedDismiss = () => {
    setCreatedKeyData(null);
    onKeysChanged();
  };

  const handleRevokeConfirm = async () => {
    if (!revokeTarget) return;
    setRevoking(true);
    try {
      await revokeMcpKey(revokeTarget.prefix || revokeTarget.id);
      toast.success(`Key "${revokeTarget.name}" revoked`);
      setRevokeTarget(null);
      onKeysChanged();
    } catch (err) {
      toast.error("Failed to revoke key");
    } finally {
      setRevoking(false);
    }
  };

  const hasKeys = keys && keys.length > 0;

  return (
    <Section title="API Keys" subtitle="Manage access keys for AI agents" id="mcp-keys">
      {!hasKeys && !loading ? (
        <EmptyState
          icon={
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
            </svg>
          }
          title="Connect AI agents to your wallet"
          description="Generate an API key to let Claude, Copilot, Cursor, or any MCP-compatible AI agent manage your wallet with spending controls."
          action={
            <button
              type="button"
              className="fugu--btn mcp-btn-primary"
              onClick={() => setShowGenerate(true)}
            >
              <span>Generate API key</span>
            </button>
          }
        />
      ) : (
        <>
          <div className="mcp-keys-header">
            <button
              type="button"
              className="fugu--btn mcp-btn-primary"
              onClick={() => setShowGenerate(true)}
            >
              <span>+ Generate new key</span>
            </button>
          </div>
          <KeysList keys={keys || []} onRevoke={setRevokeTarget} />
        </>
      )}

      <GenerateKeyModal
        show={showGenerate}
        onClose={() => setShowGenerate(false)}
        onKeyCreated={handleKeyCreated}
      />

      <KeyCreatedModal
        show={!!createdKeyData}
        onClose={handleKeyCreatedDismiss}
        keyData={createdKeyData}
      />

      <NormaAlert
        show={!!revokeTarget}
        handleCloseParent={() => setRevokeTarget(null)}
        message={`Are you sure you want to revoke the key <strong>"${revokeTarget?.name}"</strong>? This cannot be undone.`}
        agreeAction={handleRevokeConfirm}
      />
    </Section>
  );
}
